/* eslint-disable no-case-declarations */

import {
    POST_SCORE_FETCH_POSTABLE_MATCHUPS,
    POST_SCORE_FETCH_POSTABLE_MATCHUPS_SUCCESS,
    POST_SCORE_FETCH_POSTABLE_MATCHUPS_FAILURE,
    POST_SCORE_FETCH_MATCH,
    POST_SCORE_FETCH_MATCH_SUCCESS,
    POST_SCORE_FETCH_MATCH_FAILURE,
} from '../actions/post-score-actions';
import { MatchFormatTypes } from '../utils/postScoreConstants';

const initialState = {
    postableMatchups: {
        total: 0,
        top: 5,
        skip: 0,
        hits: [],
        isLoading: false,
        error: false,
        currentMatchup: null,
    },
    redirectUrlPage: '',
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'POST_SCORE:ADD_PLAYER': {
            const { key, player } = action;
            return {
                ...state,
                [key]: player,
            };
        }
        case 'POST_SCORE:POST_SCORE_REQUEST': {
            return {
                ...state,
                loading: true,
                submitted: false,
            };
        }
        case 'POST_SCORE:POST_SCORE_FAILURE': {
            return {
                ...state,
                loading: false,
                submitted: false,
            };
        }
        case 'POST_SCORE:POST_SCORE_SUCCESS': {
            return {
                ...state,
                loading: false,
                submitted: true,
            };
        }
        case 'POST_SCORE:SET_ROUND': {
            const { eventId, selectedDrawId, roundIndex, matchIndex, activeRound, redirectUrlPage } = action.data;
            return {
                ...state,
                eventId,
                selectedDrawId,
                roundIndex,
                matchIndex,
                activeRound,
                redirectUrlPage,
            };
        }
        case 'POST_SCORE:SET_PLAYER_POSTED_MATCH':
            const { result } = action.data;
            return {
                ...state,
                result,
            };
        case 'POST_SCORE:CLEAR':
            return {
                ...state,
                result: null,
                pos1player1: null,
                pos1player2: null,
                pos2player1: null,
                pos2player2: null,
                submitted: false,
                loading: false,
            };
        case POST_SCORE_FETCH_POSTABLE_MATCHUPS:
            return {
                ...state,
                postableMatchups: {
                    ...state.postableMatchups,
                    isLoading: true,
                    error: false,
                    hits: action.initialFetch ? [] : state.postableMatchups.hits,
                },
            };
        case POST_SCORE_FETCH_POSTABLE_MATCHUPS_SUCCESS:
            const { postableMatchups } = state;
            if (postableMatchups.hits && postableMatchups.hits.length > 0) {
                postableMatchups.hits = postableMatchups.hits.concat(action.data.results);
            } else {
                postableMatchups.hits = action.data.results;
            }
            postableMatchups.total = action.data.totalCount;
            postableMatchups.skip = action.skip;
            postableMatchups.isLoading = false;
            return {
                ...state,
                postableMatchups,
            };
        case POST_SCORE_FETCH_POSTABLE_MATCHUPS_FAILURE:
            return {
                ...state,
                postableMatchups: {
                    ...state.postableMatchups,
                    isLoading: false,
                    error: true,
                },
            };
        case POST_SCORE_FETCH_MATCH:
            return {
                ...state,
                postableMatchups: {
                    ...state.postableMatchups,
                    isLoading: true,
                    currentMatchup: null,
                    error: false,
                },
            };
        case POST_SCORE_FETCH_MATCH_SUCCESS:
            return {
                ...state,
                postableMatchups: {
                    ...state.postableMatchups,
                    isLoading: false,
                    currentMatchup: action.data,
                },
                result: action.data?.result ? {
                    ...action.data?.result,
                    gameType: action.data?.result?.players?.winner2 || action.data?.result?.players?.loser2 ? MatchFormatTypes.DOUBLES : MatchFormatTypes.SINGLES,
                } : null,
            };
        case POST_SCORE_FETCH_MATCH_FAILURE:
            return {
                ...state,
                postableMatchups: {
                    ...state.postableMatchups,
                    isLoading: false,
                    error: true,
                },
            };
        default:
            return state;
    }
}

export default app;
